import Vue from "vue";
import Router from "vue-router";
const AccessKeys = () => import(/* webpackChunkName: "hm-access-keys" */ "../views/AccessKeys.vue");
const AccessKeyForm = () => import(/* webpackChunkName: "hm-access-key-form" */ "../views/AccessKeyForm.vue");
const AccessLogs = () => import(/* webpackChunkName: "hm-access-logs" */ "../views/AccessLogs.vue");
const Users = () => import(/* webpackChunkName: "hm-users" */ "../views/Users.vue");
const Chases = () => import(/* webpackChunkName: "hm-chases" */ "../views/Chases.vue");
const ChaseUsers = () => import(/* webpackChunkName: "hm-chase-users" */ "../views/ChaseUsers.vue");
const Calculator = () => import(/* webpackChunkName: "hm-calculator" */ "../views/Calculator.vue");
const OmissionDashboard = () => import(/* webpackChunkName: "hm-omission" */ "../views/OmissionDashboard.vue");
const Lottery = () => import(/* webpackChunkName: "hm-lottery" */ "../views/Lottery.vue");
const Login = () => import(/* webpackChunkName: "hm-login" */ "../views/Login.vue");
import { isAuthenticated, restoreSession } from "../services/auth";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    { path: "/login", name: "login", component: Login },
    { path: "/access-keys", name: "access-keys", component: AccessKeys },
    { path: "/access-keys/new", name: "access-key-new", component: AccessKeyForm },
    { path: "/access-keys/:id", name: "access-key-edit", component: AccessKeyForm },
    { path: "/access-logs", name: "access-logs", component: AccessLogs },
    { path: "/users", name: "users", component: Users },
    { path: "/chases", name: "chases", component: Chases },
    { path: "/chase-users", name: "chase-users", component: ChaseUsers },
    { path: "/lottery", name: "lottery", component: Lottery },
    { path: "/calculator", name: "calculator", component: Calculator },
    { path: "/omission", name: "omission", component: OmissionDashboard },
    { path: "/", redirect: "/access-keys" },
    { path: "*", redirect: "/access-keys" }
  ]
});

router.beforeEach(async (to, from, next) => {
  const publicPaths = ["/login", "/script-login", "/script-login/success"];

  if (publicPaths.includes(to.path)) {
    if (to.path === "/login" && isAuthenticated()) return next("/access-keys");
    return next();
  }

  if (isAuthenticated()) return next();
  const ok = await restoreSession();
  if (ok) return next();
  const redirect = encodeURIComponent(to.fullPath);
  return next(`/login?redirect=${redirect}`);
});

export default router;
